module.exports = __webpack_public_path__ + "static/udoh-9d789534bd224aaf53f152c987bc6903.jpg";